import { render, staticRenderFns } from "./goodsTag.vue?vue&type=template&id=af81b4f0&scoped=true&"
import script from "./goodsTag.vue?vue&type=script&lang=js&"
export * from "./goodsTag.vue?vue&type=script&lang=js&"
import style0 from "./goodsTag.vue?vue&type=style&index=0&id=af81b4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af81b4f0",
  null
  
)

component.options.__file = "goodsTag.vue"
export default component.exports